import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "注册账号", -1)

import { reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { User,Lock,Iphone,Message } from '@element-plus/icons-vue';
import $http from '../http/index';

export interface DataItem {
    Item1: string,
    Item2: string,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'RegistPage',
  emits: ['registComplete','goHome'],
  setup(__props, { emit }) {


class InitData{
    account=''
    password=''
    phone=''
    code=''
    countdown=0
    codeButtonState=true;//验证码按钮状态
    codeButtonText="获取验证码"
    userClassifyDataDictionary:Array<DataItem>=[]
    userClassify=''
}
const data = reactive(new InitData());

onMounted(()=>{
    getUserClassifyDataDictionary();
});

/**
 * 注册
 */
const regist=()=>{
    const param = {
        UserClassify:data.userClassify,
        Account:data.account,
        Phone:data.phone,
        VerificationCode:data.code,
        Pwd:data.password
    };
    $http({
        url: `/API/FrontEndUser/UserRegist`,
        method: "post",
        data: {
            user:JSON.stringify(param)
        }
    }).then(() => {
        data.userClassify='';
        data.account='';
        data.phone='';
        data.code='';
        data.password='';
        emit("registComplete");
    });
}

const goLogin=()=>{
    emit("registComplete");
}

/**
 * 游客入口
 */
const TouristEntrance=()=>{
    emit("goHome");
}

/**
 * 发送注册验证码
 */
const sendRegistVerificationCode=()=>{
    if(!data.phone){
        ElMessage({
            showClose: false,
            message: '手机号不能为空',
        })
        return;
    }
    if(data.phone.length!=11){
        ElMessage({
            showClose: false,
            message: '手机号需为11为数字',
        })
        return;
    }
    if(data.countdown>0){
        return;
    }
    data.countdown = 60; // 倒计时的秒数 
    let intervalId = setInterval(function() {  
        data.codeButtonText = `再次获取${data.countdown}`
        data.countdown--;  
        if(data.countdown <= 0) {  
            data.codeButtonText="获取验证码"
            clearInterval(intervalId); // 当倒计时结束时，停止倒计时  
        }  
    }, 1000); // 每秒执行一次
    $http({
        url: `/API/FrontEndUser/SendRegistVerificationCode`,
        method: "post",
        data: {
            phone:data.phone,
        }
    });
}

const getUserClassifyDataDictionary=()=>{
    $http({
        url: `/API/FrontEndUser/GetUserClassifyDataDictionary`,
        method: "post",
        data: {
        }
    }).then(res => {
        data.userClassifyDataDictionary = res.data
    });
}


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"center","font-size":"26px"}
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.userClassify,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.userClassify) = $event)),
              class: "userClassifyStyle",
              placeholder: "选择您的身份",
              size: "default"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"vertical-align":"middle","width":"45.6px","background-color":"#f5f7fa","height":"32px","left":"-10px","border-right":"#CCC 1px solid"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.userClassifyDataDictionary, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.Item1,
                    label: item.Item2,
                    value: item.Item1
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              placeholder: "填写您的账号",
              modelValue: data.account,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.account) = $event))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_el_button, { icon: _unref(User) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              placeholder: "填写您的手机号",
              modelValue: data.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.phone) = $event))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_el_button, { icon: _unref(Iphone) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              placeholder: "输入验证码",
              modelValue: data.code,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.code) = $event))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_el_button, { icon: _unref(Message) }, null, 8, ["icon"])
              ]),
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  text: "",
                  onClick: sendRegistVerificationCode,
                  disabled: !data.codeButtonState
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.codeButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              placeholder: "填写密码",
              modelValue: data.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.password) = $event)),
              type: "password"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_el_button, { icon: _unref(Lock) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "danger",
              style: {"width":"100%"},
              onClick: regist
            }, {
              default: _withCtx(() => [
                _createTextVNode("注册")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: {"width":"100%","color":"#CCCCCC","cursor":"pointer"},
              onClick: TouristEntrance
            }, "游客入口")
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: {"text-align":"right","color":"#FF0000","cursor":"pointer","float":"right"},
              onClick: goLogin
            }, "已有账号，马上登录>>")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})